<template>
  <div class="mm-page-main"   v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">小票機管理</div>

    </div>
    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>小票機列表</h3>
          </div>
          <div>
            <el-button @click="setfrprint()" class="text-white">打印設置</el-button>
            <el-button @click="addfrprint()" class="text-white">添加小票機</el-button>
          </div>
        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">

            <el-table-column prop="name" label="小票機名稱" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">小票機名稱</div>
                <div>{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="sn" label="SN" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">SN</div>
                <div>{{scope.row.sn}}</div>
              </template>
            </el-table-column>
            <el-table-column sortable prop="scene" label="使用場所" align="center">
              <template slot-scope="scope">
                <div class="phonecel">使用場所</div>
                <div v-if="scope.row.scene== 0">門店</div>
                <div v-else>辦公室</div>
              </template>
            </el-table-column>
            <el-table-column sortable prop="status" label="狀態" align="center">
              <template slot-scope="scope">
                <div class="phonecel">狀態</div>
                <div v-if="scope.row.status == 0">啟用</div>
                <div v-else>禁用</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <div class="phonecel">操作</div>
              <template slot-scope="scope">
                <el-button @click="delfrpint(scope.row.id)" size="mini">刪除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {

  data () {
    return {
      mso_id:0,
      loading: true,
      store_id: 0,
      stores: [],
      data: [],
      transform: '',
      transformnum: 0,
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    setfrprint () {
      this.$router.push({
        name: '/SetFrprint',
        path: '/SetFrprint',
        params: {
          id: this.store_id
        }
      })
    },
    addfrprint () {

      this.$router.push({
        name: '/AddFrprint',
        path: '/AddFrprint',
        params: {
          id: this.store_id
        }
      })
    },
    delfrpint (frprint_id) {

      this.post('/api/frprint/delfrpint', {
        frprint_id: frprint_id
      }).then((res) => {
        this.loading = false;
        this.getfeprint();


      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },

    getfeprint () {
      this.post('/api/frprint/getfeprint', {
        store_id: this.store_id
      }).then((res) => {
        this.loading = false;

        this.data = res;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },

    changestore (store_id) {
      this.store_id = store_id;
      sessionStorage.setItem('tab_frprint_store_id', store_id);
      this.getfeprint();
    },

    gotoruter (name) {
      this.$router.push(name)
    },
    getstore () {

      this.post('/api/store/index', {

      }).then((res) => {

        if (res.length > 0 && this.store_id == 0) {
          this.store_id = res[0].id;
        }
        this.stores = res;


      }).catch((err) => {

        console.log(err)
      }).then(() => {
        this.getfeprint();
      })


    }

  },
  created () {
    this.mso_id = sessionStorage.getItem('mso_id');
    let store_id = sessionStorage.getItem('tab_frprint_store_id') || 0;
    this.store_id = store_id;
    this.getstore();
  },


}
</script>

<style scoped>
</style>
